const i = (t, e) => t ? t.charAt(0).toUpperCase() + t.slice(1) : e ?? "", r = {
  capitalize: i
};
export {
  r as StringUtils,
  i as capitalize
};
